import { type ReactNode } from 'react';
import { clsx } from 'clsx';

type Tone = 'slate' | 'green' | 'blue' | 'yellow' | 'red' | 'purple';

const toneClasses: Record<Tone, string> = {
  slate: 'bg-[var(--color-paper-2)] text-[var(--color-ink)]',
  green: 'bg-[var(--color-success)] text-white dark:text-[#0f0f10]',
  blue: 'bg-[var(--color-info-soft)] text-[var(--color-info)]',
  yellow: 'bg-[#f08c00] text-white dark:bg-[var(--color-warning)] dark:text-[#0f0f10]',
  red: 'bg-[var(--color-accent-soft)] text-[var(--color-accent-strong)]',
  purple: 'bg-[#EDE9FE] text-[#7C3AED] dark:bg-[#2E1065] dark:text-[#C4B5FD]',
};

export function Badge({ tone = 'slate', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded border border-transparent px-1.5 py-0.5',
        'text-[0.6875rem] font-bold uppercase tracking-wide',
        toneClasses[tone],
      )}
    >
      {children}
    </span>
  );
}
